<main class="main-dashboard">
    <article class="main-canvas">
      <section class="canvas-container">
        <section class="dashboard-items">
          <div class="canvas-item">
            <div
              class="canvas-header row justify-content-between align-items-center"
            >
              <div class="title col-sm-6">
                <h3>Feature List</h3>
              </div>
              <div class="col-sm-6 d-flex justify-content-end">
                <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                  <button
                    type="button"
                    (click)="editOpenModal()"
                    data-bs-toggle="modal"
                    data-bs-target="#createFeatureList"
                  >
                    <span><i class="ri-pencil-line"></i></span>
                  </button>
                </div>
                <div class="delete" *ngIf="selectedCheckboxData.length > 0">
                  <button
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#deleteFeatureList"
                    (click)="deleteOpenModal()"
                  >
                    <span><i class="ri-delete-bin-5-line"></i></span>
                  </button>
                </div>
                <div>
                  <button
                    type="button"
                    (click)="createOpenModal()"
                    data-bs-toggle="modal"
                    data-bs-target="#createFeatureList"
                    class="btn btn-icon"
                  >
                    <i class="ri-add-line"></i>
                  </button>
                </div>
              </div>
            </div>
            <ag-grid-angular
              style="height: calc(100vh - 120px) !important;" 
              class="ag-theme-material"
              (gridReady)="onGridReady($event)"
              [rowData]="rowData"
              [columnDefs]="columnDefs"
              pagination="true"
              [defaultColDef]="defaultColDef"
              [suppressRowClickSelection]="true"
              [rowSelection]="rowSelection"
              (selectionChanged)="onSelectionChanged($event)"
              paginationPageSize="10"
            >
            </ag-grid-angular>
          </div>
        </section>
      </section>
    </article>
  </main>

  <!-- Create new Lead -->
<div class="modal fade bd-example-modal-lg" id="createFeatureList" tabindex="-1">
    <div class="modal-dialog  modal-lg">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="featurelistForm">
                <div class="modal-header">
                    <h5 class="modal-title">Feature List</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                 <div class="container">
                  <div class="row">  
                    <div class="col-sm">    
                      <div class="input">
                        <div class="input-item">
                            <input formControlName="featureName" type="text" required>
                            <label for="featureName" class="floating-label">Feature Name</label>
                            <i class="ri-file-list-line"></i>
                        </div>
                        <mat-error *ngIf="f.featureName.invalid && (f.featureName.dirty ||f.featureName.touched)" class="alert alert-danger">
                          <mat-error *ngIf="f.featureName.errors.required">
                             FeatureName is required
                          </mat-error>
                        </mat-error>  
                     </div>
                    </div>
                    <div class="col-sm"> 
                      <div class="input">
                        <div class="input-item">
                            <input formControlName="extraField1" type="text" >
                            <label for="extraField1" class="floating-label">Project Name</label>
                            <i class="ri-file-shield-fill"></i>
                        </div>
                      </div>
                    </div> 
                  </div>  
                  <div class="row">
                    <div class="col-sm"> 
                     <div class="input">
                        <div class="input-item">
                            <input formControlName="featureFamilyCategory" type="text" required>
                            <label for="featureFamilyCategory" class="floating-label">Feature Family Category</label>
                            <i class="ri-building-line"></i>
                        </div> <mat-error *ngIf="f.featureFamilyCategory.invalid && (f.featureFamilyCategory.dirty ||f.featureFamilyCategory.touched)" class="alert alert-danger">
                          <mat-error *ngIf="f.featureFamilyCategory.errors.required">
                             Customer is required
                          </mat-error>
                        </mat-error>  

                     </div>
                    </div> 
                  <div class="col-sm"> 
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="featureFamilyCode" type="text" required>
                            <label for="featureFamilyCode" class="floating-label">Feature Family Code</label>
                            <i class="ri-code-box-fill"></i>
                        </div>
                        <mat-error *ngIf="f.featureFamilyCode.invalid && (f.featureFamilyCode.dirty ||f.featureFamilyCode.touched)" class="alert alert-danger">
                          <mat-error *ngIf="f.featureFamilyCode.errors.required">
                             featureFamilyCode is required
                          </mat-error>
                        </mat-error>  
                    </div>
                   </div> 
                 </div> 
                 <div class="row">
                    <div class="col-sm">  
                     <div class="input">
                        <div class="input-item">
                            <input formControlName="featureFamilyName" type="text">
                            <label for="featureFamilyName" class="floating-label">Feature Family Name</label>
                            <i class="ri-profile-fill"></i>
                        </div>
                     </div>
                    </div>
                    <div class="col-sm"> 
                     <div class="input">
                        <div class="input-item">
                            <input formControlName="featureCode" type="text" required>
                            <label for="featureCode" class="floating-label">Feature Code</label>
                            <i class="ri-slideshow-line"></i>  
                        </div> 
                        <mat-error *ngIf="f.featureCode.invalid && (f.featureCode.dirty ||f.featureCode.touched)" class="alert alert-danger">
                          <mat-error *ngIf="f.featureCode.errors.required">
                             featureCode is required
                          </mat-error>
                          <mat-error *ngIf="f.featureCode.errors.pattern">
                            featureCode should be number.
                         </mat-error>
                        </mat-error>  

                     </div>
                    </div> 
                 </div>  
                 <div class="row">
                    <div class="col-sm">  
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="effectiveState" type="text" >
                            <label for="effectiveState" class="floating-label">Effective State</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                    </div>
                    </div>
                    <div class="col-sm">
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="effectiveDate" type="date" >
                            <label for="effectiveDate" class="floating-label">Effective Date</label>
                            <i class="ri-calendar-2-line"></i>
                        </div>
                    </div>
                    </div>
                 </div> 
                 <div class="row">
                    <div class="col-sm">
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="featureChangeOrderNumber" type="text" >
                            <label for="featureChangeOrderNumber" class="floating-label">Feature Change Order Number</label>
                            <i class="ri-numbers-fill"></i>
                           
                        </div>
                    </div>
                   </div> 
                   <div class="col-sm">
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="featureChangeOrderStatus" type="text" >
                            <label for="featureChangeOrderStatus" class="floating-label">Feature Change Order Status</label>
                            <i class="ri-time-line"></i>
                        </div>
                    </div>
                   </div>
                 </div> 
                 <div class="row">
                 <div class="col-sm">
                    <div class="input">
                        <div class="input-item">
                            <textarea formControlName="comment" type="text" rows="3" cols="100" ></textarea>
                            <label for="comment" class="floating-label">Comment</label>
                            <!-- <i class="ri-time-line"></i> -->
                        </div>
                    </div>
                  </div>
                 </div>
                </div>
               </div>
                <div class="modal-footer">
                    <button type="button" id="closeCreateModal" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createFeatureList()" [disabled]="!featurelistForm.valid?true:null">Create</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" (click)="updateFeatureList()" >Update</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete an item -->
<div class="modal fade" id="deleteFeatureList" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form action="">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure want to delete?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="text-center">
                        <p>{{deleteConfirmationMsg}}?</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModalDeleteFeaturelist" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="selectedCheckboxData.length > 0" (click)="deleteFeatureList()">Yes Delete</button>
                </div>
            </form>
        </div>
    </div>
</div> 
